import { render, staticRenderFns } from "./edit-admin.vue?vue&type=template&id=e756d94e&scoped=true&"
import script from "./edit-admin.vue?vue&type=script&lang=ts&"
export * from "./edit-admin.vue?vue&type=script&lang=ts&"
import style0 from "./edit-admin.vue?vue&type=style&index=0&id=e756d94e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e756d94e",
  null
  
)

component.options.__file = "edit-admin.vue"
export default component.exports